import { app } from '../../../../../app';

app.service('ImportSharedAuthenticatorsModal', modal);

/** @ngInject */
function modal($uibModal) {
    return () => $uibModal.open({
        component: 'companySharingCenterSharedAuthenticatorsImport',
        resolve: {authenticators},
    }).result
}

/** @ngInject */
function authenticators($filter, Authenticator) {
    return Authenticator.query().$promise
       // .then((items) => $filter('filter')(items, {ssoEnabled: true}))
        .then((items) => $filter('orderBy')(items, 'publicService.serviceName'));
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/import/import-shared-authenticator.modal.js